import { template as template_faf466881ea8466da96fed085a38f07a } from "@ember/template-compiler";
import { action } from '@ember/object';
import Component from '@glimmer/component';
/**
  Renders a `<thead>` element and yields the column component.
  ```hbs
  <table.header as |header|>
    <header.column @prop="firstName">
      First name
    </header.column>
    <header.column @prop="lastName">
      Last name
    </header.column>
    <header.column @prop="points">
      Points
    </header.column>
  </table.header>
  ```

  @class Header
  @yield {object} header
  @yield {Component} header.column       the column component
*/ import THead from './thead/row/column.gjs';
import { hash } from '@ember/helper';
export default class Header extends Component {
    static{
        template_faf466881ea8466da96fed085a38f07a(`
    <thead class={{@theme.thead}} ...attributes>
      <tr class='{{@trClass}} {{@theme.theadRow}} {{@theme.row}}'>
        {{yield
          (hash
            column=(component
              THead
              sortable=@sortable
              sortSequence=@sortSequence
              onClick=this.onColumnClickHeader
              parent=@parent
              theme=@theme
            )
          )
        }}
      </tr>
    </thead>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @action
    onColumnClickHeader(column, e) {
        if (this.args.onColumnClick && column.sortable) {
            this.args.onColumnClick(column, e);
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL2hlYWRlci5nanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYWN0aW9uIH0gZnJvbSAnQGVtYmVyL29iamVjdCc7XG5cbmltcG9ydCBDb21wb25lbnQgZnJvbSAnQGdsaW1tZXIvY29tcG9uZW50JztcblxuLyoqXG4gIFJlbmRlcnMgYSBgPHRoZWFkPmAgZWxlbWVudCBhbmQgeWllbGRzIHRoZSBjb2x1bW4gY29tcG9uZW50LlxuICBgYGBoYnNcbiAgPHRhYmxlLmhlYWRlciBhcyB8aGVhZGVyfD5cbiAgICA8aGVhZGVyLmNvbHVtbiBAcHJvcD1cImZpcnN0TmFtZVwiPlxuICAgICAgRmlyc3QgbmFtZVxuICAgIDwvaGVhZGVyLmNvbHVtbj5cbiAgICA8aGVhZGVyLmNvbHVtbiBAcHJvcD1cImxhc3ROYW1lXCI-XG4gICAgICBMYXN0IG5hbWVcbiAgICA8L2hlYWRlci5jb2x1bW4-XG4gICAgPGhlYWRlci5jb2x1bW4gQHByb3A9XCJwb2ludHNcIj5cbiAgICAgIFBvaW50c1xuICAgIDwvaGVhZGVyLmNvbHVtbj5cbiAgPC90YWJsZS5oZWFkZXI-XG4gIGBgYFxuXG4gIEBjbGFzcyBIZWFkZXJcbiAgQHlpZWxkIHtvYmplY3R9IGhlYWRlclxuICBAeWllbGQge0NvbXBvbmVudH0gaGVhZGVyLmNvbHVtbiAgICAgICB0aGUgY29sdW1uIGNvbXBvbmVudFxuKi9cblxuaW1wb3J0IFRIZWFkIGZyb20gJy4vdGhlYWQvcm93L2NvbHVtbi5nanMnO1xuaW1wb3J0IHsgaGFzaCB9IGZyb20gJ0BlbWJlci9oZWxwZXInO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBIZWFkZXIgZXh0ZW5kcyBDb21wb25lbnQge1xuICA8dGVtcGxhdGU-XG4gICAgPHRoZWFkIGNsYXNzPXt7QHRoZW1lLnRoZWFkfX0gLi4uYXR0cmlidXRlcz5cbiAgICAgIDx0ciBjbGFzcz0ne3tAdHJDbGFzc319IHt7QHRoZW1lLnRoZWFkUm93fX0ge3tAdGhlbWUucm93fX0nPlxuICAgICAgICB7e3lpZWxkXG4gICAgICAgICAgKGhhc2hcbiAgICAgICAgICAgIGNvbHVtbj0oY29tcG9uZW50XG4gICAgICAgICAgICAgIFRIZWFkXG4gICAgICAgICAgICAgIHNvcnRhYmxlPUBzb3J0YWJsZVxuICAgICAgICAgICAgICBzb3J0U2VxdWVuY2U9QHNvcnRTZXF1ZW5jZVxuICAgICAgICAgICAgICBvbkNsaWNrPXRoaXMub25Db2x1bW5DbGlja0hlYWRlclxuICAgICAgICAgICAgICBwYXJlbnQ9QHBhcmVudFxuICAgICAgICAgICAgICB0aGVtZT1AdGhlbWVcbiAgICAgICAgICAgIClcbiAgICAgICAgICApXG4gICAgICAgIH19XG4gICAgICA8L3RyPlxuICAgIDwvdGhlYWQ-XG4gIDwvdGVtcGxhdGU-XG4gIEBhY3Rpb25cbiAgb25Db2x1bW5DbGlja0hlYWRlcihjb2x1bW4sIGUpIHtcbiAgICBpZiAodGhpcy5hcmdzLm9uQ29sdW1uQ2xpY2sgJiYgY29sdW1uLnNvcnRhYmxlKSB7XG4gICAgICB0aGlzLmFyZ3Mub25Db2x1bW5DbGljayhjb2x1bW4sIGUpO1xuICAgIH1cbiAgfVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxTQUFTLE1BQU0sUUFBUSxnQkFBZ0I7QUFFdkMsT0FBTyxlQUFlLHFCQUFxQjtBQUUzQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW1CQSxHQUVBLE9BQU8sV0FBVyx5QkFBeUI7QUFDM0MsU0FBUyxJQUFJLFFBQVEsZ0JBQWdCO0FBRXJDLGVBQWUsTUFBTSxlQUFlO0lBQ2xDLE1BQUE7UUFBQSwwQ0FBVSxDQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztFQWlCVixDQUFBLEVBQUE7WUFBQSxXQUFBLElBQVc7WUFBWDtnQkFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7WUFBRDtRQUFBO0lBQUEsQ0FqQkE7SUFrQlYsQ0FBQztJQUNELG9CQUFvQixNQUFNLEVBQUUsQ0FBQyxFQUFFO1FBQzdCLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxhQUFhLElBQUksT0FBTyxRQUFRLEVBQUU7WUFDOUMsSUFBSSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsUUFBUTtRQUNsQztJQUNGO0FBQ0YifQ